<template>
	<div class="hero-video">
        <!-- <div class="hero-img"></div> -->
        <!-- <img class="hero-img" src="/img/hero.jpg" alt=""> -->
		<!-- <video autoplay loop muted playsinline poster="/img/jaks_hero-poster.jpg"> -->
        <video autoplay="autoplay" muted loop playsinline>
			<source src="/vid/jaks_hero-video.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: 'Hero',
        mounted: () => {
            try {
                document.querySelector( ".hero-video video" ).play();
            } catch ( e ) {
                console.log( "Video playback error", e );
            }
        }
	}
</script>